import React from "react";
import {
  Box,
  Card,
  CardContent,
  Tab,
  Tabs,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import PropTypes from "prop-types";

import {
  CARRIER_PROFILE_TABS_CARD_VM_SHAPE,
} from "./carrierProfileVmPropTypes";
import CarrierTeamMembersTabPanel from "./tabs/CarrierTeamMembersTabPanel";
import CarrierCompaniesTabPanel from "./tabs/CarrierCompaniesTabPanel";
import CarrierCommissionsTabPanel from "./tabs/CarrierCommissionsTabPanel";
import CarrierLimitsTabPanel from "./tabs/CarrierLimitsTabPanel";
import CarrierStatesTabPanel from "./tabs/CarrierStatesTabPanel";
import CarrierBondsTabPanel from "./tabs/CarrierBondsTabPanel";
import CarrierCarrierInfoTabPanel from "./tabs/CarrierCarrierInfoTabPanel";

export default function CarrierProfileTabsCard({ vm }) {
  const {
    setTabValue,
    teamMembers,
    commissions,
    licenseInfos,
    carrierLimits,
    tabValue,
    companies,
    states,
    bonds,
  } = vm;

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Card elevation={3} sx={{ borderRadius: "16px" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabValue}
              onChange={(e, v) => setTabValue(v)}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label={`Team Members (${teamMembers.length})`} />
              <Tab label={`Companies (${companies.length})`} />
              <Tab label={`Commissions (${commissions.length})`} />
              <Tab label={`Limits (${carrierLimits.length})`} />
              <Tab label={`States (${states.length})`} />
              <Tab label={`Bonds (${bonds.length})`} />
              <Tab label={`Carrier Info (${licenseInfos.length})`} />
            </Tabs>
          </Box>
          <CardContent sx={{ padding: 3 }}>
            <Box sx={{ display: tabValue === 0 ? "block" : "none" }}>
              <CarrierTeamMembersTabPanel vm={vm} />
            </Box>
            <Box sx={{ display: tabValue === 1 ? "block" : "none" }}>
              <CarrierCompaniesTabPanel vm={vm} />
            </Box>
            <Box sx={{ display: tabValue === 2 ? "block" : "none" }}>
              <CarrierCommissionsTabPanel vm={vm} />
            </Box>
            <Box sx={{ display: tabValue === 3 ? "block" : "none" }}>
              <CarrierLimitsTabPanel vm={vm} />
            </Box>
            <Box sx={{ display: tabValue === 4 ? "block" : "none" }}>
              <CarrierStatesTabPanel vm={vm} />
            </Box>
            <Box sx={{ display: tabValue === 5 ? "block" : "none" }}>
              <CarrierBondsTabPanel vm={vm} />
            </Box>
            <Box sx={{ display: tabValue === 6 ? "block" : "none" }}>
              <CarrierCarrierInfoTabPanel vm={vm} />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

CarrierProfileTabsCard.propTypes = {
  vm: PropTypes.shape(CARRIER_PROFILE_TABS_CARD_VM_SHAPE).isRequired,
};
